

<p-card *ngFor="let s of allActivityLogs; let i = index;" class="activity-card" [ngClass]="{'unread-activity': s?.isRead===false}">
    <div class="p-d-flex cursor-pointer" (click)="openActivityDetail(s,$event)">
        <div *ngIf="s?.activityGroup" class="activity-icon {{s?.activityGroup?.colorClass}} p-shadow-3">
            <span *ngIf="!(s?.activityGroup?.subTypes.length>0 && ['Inbound Call','Outbound Call'].includes(s?.activityGroup?.subTypes[0]))" [class]="s?.activityGroup?.icon"></span>
            <img [src]="assestBaseUrl + 'icons/incoming-call.png'" alt="incomingCall"  style="width: 12px;" *ngIf="s?.activityGroup?.subTypes.length>0 && s?.activityGroup?.subTypes[0] == 'Inbound Call'" />
            <img [src]="assestBaseUrl + 'icons/outgoing-call.png'" alt="outgoingCall" style="width: 12px;" *ngIf="s?.activityGroup?.subTypes.length>0 && s?.activityGroup?.subTypes[0] == 'Outbound Call'" />
        </div>
        <div class="activity-icon bg-opportunity p-shadow-3" *ngIf="!s?.activityGroup">
            <span class="pi pi-ticket"></span>
        </div>
        <div class="activity-content">
            <ng-container *ngIf="s.activityName === 'Log' || (s.activityName=='Comment' && s.type != 'Note')">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    {{ !["Field Visit", "Email"].includes(s.type) ? s.type + ' Call' : s.type }} Log {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.activityDate | localDate}}</span>
                </span>
                <span *ngIf="!isViewMode" style="float: right;color: var(--primary-color);" (click)="toggleFavourite(s.objectData?.id, !s.isFavorite, s)">
                    <i class="pi pi-star" *ngIf="!s.isFavorite"></i>
                    <i class="pi pi-star-fill" *ngIf="s.isFavorite"></i>
                </span>
                <!-- <h6 class="p-mb-1" *ngIf="s?.type">
                    Logged
                    <span *ngIf="s.type[0]">
                        {{ ['a', 'e', 'i', 'o', 'u'].includes(s.type[0].toLowerCase()) ? 'an' : 'a' }}
                    </span> {{ !["Field Visit", "Email"].includes(s.type) ? s.type + ' Call' : s.type }}
                </h6> -->
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <!-- <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                    {{ (s.description !== undefined || s.description !== "") && s.description?.length
                    < 343 ? s.description : s.description.substring(0,343) + "..." }} </p> -->
                <div [innerHtml]="getTruncatedDescription(s.viewDescription)"></div>
                <p *ngIf="s?.objectData?.log?.logAttachments?.length>0" class="p-mb-0 attachment-details"><i class="pi pi-paperclip p-mr-1"></i> {{s?.objectData?.log?.logAttachments?.length}} attachment{{s?.objectData?.log?.logAttachments?.length > 1 ? "'s" : ''}} added</p>
            </ng-container>
            <ng-container *ngIf="s.type === 'Note'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    {{ s.type }} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.activityDate | localDate}}</span>
                </span>
                <span *ngIf="!isViewMode" style="float: right;color: var(--primary-color);" (click)="toggleFavourite(s.objectData?.id, !s.isFavorite, s)">
                    <i class="pi pi-star" *ngIf="!s.isFavorite"></i>
                    <i class="pi pi-star-fill" *ngIf="s.isFavorite"></i>
                </span>
                <h6 class="p-mb-1">{{s.title}}</h6>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <!-- <p style="word-break: break-word; white-space: pre-line;" class="p-mb-0">
                    {{ (s.description !== undefined || s.description !== "") && s.description?.length
                    < 343 ? s.description : s.description.substring(0,343) + "..." }} </p> -->
                    <div [innerHtml]="getTruncatedDescription(s.viewDescription)"></div>
                <p *ngIf="s?.objectData?.note?.noteAttachments?.length>0" class="p-mb-0 attachment-details"><i class="pi pi-paperclip p-mr-1"></i> {{s?.objectData?.note?.noteAttachments?.length}} attachment{{s?.objectData?.note?.noteAttachments?.length > 1 ? "'s" : ''}} added</p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Task'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    <ng-container *ngIf="!s?.moduleData?.objectId">{{ s.type }} </ng-container>{{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <span *ngIf="s?.moduleData?.name">Title: {{s?.moduleData?.name}}</span>
                <!-- <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p> -->
                <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                        {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "")
                            ? (s.objectData?.comment.length < 343
                            ? (s.objectData?.comment | stripHtml)
                            : (s.objectData?.comment.substring(0,343) + "...") | stripHtml)
                            : "" }}
                </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'Email' && s.objectData?.objectEmailAudit?.emailAuditId != refreshEmailAuditId">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <!-- {{s.activityName}} - {{s.createdByUserName}} -->
                    From - {{s.objectData.sender ? s.objectData.sender : s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span *ngIf="!s.objectData.isRead"><b>{{ s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.receivedDateTime | localDate}}</b></span>
                <span *ngIf="s.objectData.isRead"><b>{{ s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.receivedDateTime | localDate}}</b></span>
                </span>
                <span class="p-ml-2" *ngIf="s.objectData.direction === 'Received'">
                    <i class="pi pi-reply"></i>
                </span>
                <span style="float: right;">
                    <span *ngIf="s?.objectData?.objectEmailAuditSentiment?.sentimentText?.toLowerCase() == 'positive'" class="fa fa-smile-o" style="color: green;font-size: 18px;margin-top: -2px;" [pTooltip]="s?.objectData?.objectEmailAuditSentiment?.explanation? 'Sentiment: ' + s?.objectData?.objectEmailAuditSentiment?.sentimentText + '\nConfidence: ' + s?.objectData?.objectEmailAuditSentiment?.confidenceScore + '\nExplanation: ' + s?.objectData?.objectEmailAuditSentiment?.explanation : ''"
                        tooltipPosition="top"></span>
                    <span *ngIf="s?.objectData?.objectEmailAuditSentiment?.sentimentText?.toLowerCase() == 'negative'" class="fa fa-frown-o" style="color: red;font-size: 18px;margin-top: -2px;" [pTooltip]="s?.objectData?.objectEmailAuditSentiment?.explanation? 'Sentiment: ' + s?.objectData?.objectEmailAuditSentiment?.sentimentText + '\nConfidence: ' + s?.objectData?.objectEmailAuditSentiment?.confidenceScore + '\nExplanation: ' + s?.objectData?.objectEmailAuditSentiment?.explanation : ''"
                        tooltipPosition="top"></span>
                    <span *ngIf="s?.objectData?.objectEmailAuditSentiment?.sentimentText?.toLowerCase() == 'neutral'" class="fa fa-meh-o" style="color: #e8dc2c;font-size: 18px;margin-top: -2px;" [pTooltip]="s?.objectData?.objectEmailAuditSentiment?.explanation? 'Sentiment: ' + s?.objectData?.objectEmailAuditSentiment?.sentimentText + '\nConfidence: ' + s?.objectData?.objectEmailAuditSentiment?.confidenceScore + '\nExplanation: ' + s?.objectData?.objectEmailAuditSentiment?.explanation : ''"
                        tooltipPosition="top"></span>

                    <span class="p-ml-2" style="color: var(--primary-color);" (click)="refreshEmail(s.objectData?.objectEmailAudit?.emailAuditId,$event)">
                        <i class="pi pi-refresh" tooltipPosition="top" pTooltip="Sync"></i>
                    </span>
                </span>
                <br>
                <h6 class="p-mb-1 p-mt-1" style="display: inline;" *ngIf="s.objectData.direction === 'Sent'" tooltipPosition="top" pTooltip={{s?.objectData?.recipients}}>
                    To - {{s?.objectData?.recipients | splitTextByComma}}
                </h6>
                <h6 class="p-mb-1" style="display: inline;" *ngIf="s.objectData.direction === 'Received'" tooltipPosition="top" pTooltip={{s?.objectData?.recipients}}>
                    Received E-mail From - {{s?.objectData?.recipients | splitTextByComma}}
                </h6>
                <span *ngIf="!isViewMode" style="float: right;color: var(--primary-color);"
                (click)="toggleFavourite(s.objectData?.objectEmailAudit?.emailAuditId, !s.isFavorite, s)">
                    <i class="pi pi-star" *ngIf="!s.isFavorite" tooltipPosition="bottom" pTooltip="set as Favorite"></i>
                    <i class="pi pi-star-fill" *ngIf="s.isFavorite" tooltipPosition="bottom" pTooltip="set as Unfavorite"></i>
                </span>
                <ng-container *ngIf='s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.subject !==
                    "" &&
                    s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.subject?.length
                    > 140'>
                    <div class="p-d-flex">
                        <p [innerHTML]="'Subject: ' + s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length -
                            1]?.subject.substring(0, 140)" [style.font-weight]="s.objectData.isRead && 'bold'" class="p-mb-0">
                        </p>
                        <span style="color: var(--primary-color);" class="p-ml-3 p-mt-1">
                            <i class="fa fa-paperclip"></i>
                        </span>
                    </div>
                </ng-container>
                <ng-container *ngIf='s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.subject !==
                    "" &&
                    s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.subject?.length
                    < 140'>
                    <div class="p-d-flex">
                        <p [innerHTML]="'Subject: ' + s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.subject" [style.font-weight]="s.objectData.isRead && 'bold'" class="p-mb-0">

                        </p>
                    </div>
                </ng-container>
                <p style="word-break: break-word;" class="p-mb-0">{{ (s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads[s?.objectData?.objectEmailAudit?.emailAudit?.emailThreads?.length - 1]?.bodyPreview||'') | htmlToPlaintext | shorten:600 }}</p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'Email' && showSpinner && s.objectData?.objectEmailAudit?.emailAuditId === refreshEmailAuditId">
                <p-progressSpinner styleClass="activity-custom-spinner" animationDuration=".5s"></p-progressSpinner>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Case' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <div *ngIf="s?.isExternal">
                        <p><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{ s | activityBy }} {{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                    </div>
                    <div *ngIf="!s?.isExternal">
                        <span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{ s | activityBy }} {{s?.createdByUserName}}
                    </div>
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p class="p-mb-0" [innerHTML]="s?.viewDescription"></p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Account'  && s.objectData?.action!='Convert'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Account'  && s.objectData?.action=='Convert'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Lead Converted to Account by {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && (s.objectData.comment?.split(':')?.length) > 1 ? (s.objectData.comment?.split(':')[0] + ": ") : s.objectData.comment?.substring(0,343) + "..." }}
                    <a style="color: var(--primary-color);" *ngIf="(s.objectData.comment !== undefined || s.objectData.comment !== '') && (s.objectData.comment.split(':').length) > 1" (click)="convertPageNavigation(s)"> {{ s.objectData.comment?.split(':')[1] }}</a>
                </p>
            </ng-container>
            <!--  Account Category Updated -->
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityAccountLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Account Category Updated <ng-container *ngIf="s.objectData?.previousStage">from</ng-container> {{s.objectData?.previousStage}} <ng-container *ngIf="s.objectData?.stage?.name">to</ng-container> {{s.objectData?.stage?.name}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;white-space: pre; text-wrap: wrap;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Contact' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <div *ngIf="s?.isExternal">
                        <p><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{ s | activityBy }} {{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                    </div>
                    <div *ngIf="!s?.isExternal">
                        <span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{ s | activityBy }} {{s?.createdByUserName}}
                    </div>
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Lead' && s.objectData?.action!='Convert'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <div *ngIf="s?.isExternal">
                        <p>{{s.type}} {{ s | activityBy }} {{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                    </div>
                    <div *ngIf="!s?.isExternal">
                        {{s.type}} {{ s | activityBy }} {{s?.createdByUserName}}
                    </div>
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Lead'  && s.objectData?.action=='Convert'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Lead Converted to Account by {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && (s.objectData.comment?.split(':')?.length) > 1 ? (s.objectData.comment?.split(':')[0] + ": ") : s.objectData.comment?.substring(0,343) + "..." }}
                    <a style="color: var(--primary-color);" *ngIf="(s.objectData.comment !== undefined || s.objectData.comment !== '') && (s.objectData.comment.split(':').length) > 1" (click)="convertPageNavigation(s)"> {{ s.objectData.comment?.split(':')[1] }}</a>
                </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityLeadLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Lead Stage Updated <ng-container *ngIf="s.objectData?.previousStage">from</ng-container> {{s.objectData?.previousStage}} <ng-container *ngIf="s.objectData?.stage?.name">to</ng-container> {{s.objectData?.stage?.name}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;white-space: pre; text-wrap: wrap;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityCasesLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    <ng-container *ngIf="!s?.moduleData?.objectId">Case </ng-container>Stage Updated <ng-container *ngIf="s.objectData?.previousStage">from</ng-container> {{s.objectData?.previousStage}} <ng-container *ngIf="s.objectData?.stage?.name">to</ng-container> {{s.objectData?.stage?.name}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;white-space: pre; text-wrap: wrap;" class="p-mb-0">{{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveAccountLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Account {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveLeadLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Lead {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveContactLog' ">
                <h6 *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId" class="p-mb-1" style="display: inline-block;">
                    <span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <h6 *ngIf="!(objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId)" class="p-mb-1" style="display: inline-block;">
                    Contact - {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">{{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActiveInactiveOpportunityLog' ">
                <h6 *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId" class="p-mb-1" style="display: inline-block;">
                    <span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <h6 *ngIf="!(objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId)" class="p-mb-1" style="display: inline-block;">
                    Opportunity - {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate: 'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;" class="p-mb-0">{{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && ['ActiveInactiveInvoiceLog','ActiveInactiveSalesOrderLog','ActiveInactiveCustomerRmaLog','ActiveInactiveCreditMemoLog'].includes(s.type)">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - {{s | activityBy}} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;" class="p-mb-0">{{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type == 'EmailReply' ">
                <h6 class="p-mb-1" style="display: inline;">
                    <div *ngIf="s?.isExternal">
                        <p>{{s?.externalUserName}}<span *ngIf="s?.externalUserName == null">{{s?.externalUserEmail}}</span> (external)</p>
                    </div>
                    <div *ngIf="!s?.isExternal">
                        {{s?.createdByUserName}}
                    </div>
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>

            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CheckIn' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Visited by {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p *ngIf="s.description == 'Check In - Check Out' ">
                    Check In {{s.checkInDateTime | localDate: 'h:mm a'}} - Check Out {{s.checkOutDateTime | localDate: 'h:mm a'}}
                </p>
                <p *ngIf="s.description == 'Check In'">
                    Check In {{s.objectData.createdDate | localDate: 'h:mm a'}}
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CheckOut' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Visited by {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    Check Out {{s.objectData.createdDate | localDate: 'h:mm a'}}
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'AddressChange' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Location Updated by {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">{{ s?.objectData?.refObjectId==2?'Account':'Lead' }} location updated while check in.</p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityOpportunityLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    <ng-container *ngIf="!s?.moduleData?.objectId">Opportunity </ng-container>Stage Updated <ng-container *ngIf="s.objectData?.previousStage">from</ng-container> {{s.objectData?.previousStage}} <ng-container *ngIf="s.objectData?.stage?.name">to</ng-container> {{s.objectData?.stage?.name}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <div *ngIf="!s?.moduleData">Amount: {{ s.objectData.netAmount | currencySymbol}}</div>
                <p style="word-break: break-all;white-space: pre; text-wrap: wrap;" class="p-mb-0">{{ (s.objectData.comment !== undefined || s.objectData.comment !== "") && s.objectData.comment?.length
                    < 343 ? s.objectData.comment : s.objectData.comment?.substring(0,343) + "..." }} </p>
            </ng-container>
            <!-- <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityCasesLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Case - {{s.createdByUserName}} - {{s.objectData.stage?.name}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0" [innerHTML] = s?.description>

                </p>
            </ng-container> -->
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'AssignUser' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    User Assigned {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;" class="p-mb-0" [innerHTML]=s?.viewDescription></p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ResolutionDateChange' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;" class="p-mb-0" [innerHTML]=s?.viewDescription></p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'StageChange' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    {{s?.description}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                    {{ (s?.objectData?.comment !== undefined || s?.objectData?.comment !== "") && s?.objectData?.comment?.length
                    < 343 ? s?.objectData?.comment : s?.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Opportunity'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span class="module-details">{{ s | activityModuleName }}</span> - {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate:'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div>{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0" [innerHTML]="s?.viewDescription"></p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Estimate' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span class="module-details">{{s.type}} {{s?.moduleData?.sequenceNumber}}</span> - {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData?.createdDate | localDate: 'MM/DD/YYYY | h:mm a'}}</span>
                </span>
                <div *ngIf="!s?.payloadDetails && s?.moduleData">{{ s | activityModuleDetails }}</div>
                <p class="p-mb-0" *ngIf="s.payloadDetails"> {{s.type}} - {{s.payloadDetails?.netAmount | number: "1.2-2"}} , {{s.payloadDetails?.estimateStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                <!-- Estimates create from workflow -->
                 <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action != 'Update' && s.objectData?.action != 'ApprovalFromWF'">
                    Estimate {{s?.moduleData?.sequenceNumber}} created from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <!-- Estimates update from workflow -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'Update'">
                    Estimate {{s?.moduleData?.sequenceNumber}} updated from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <!-- Estimates to SalesOrder Comment -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.payloadDetails?.salesOrderId != 0 && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                    Estimate {{s?.moduleData?.sequenceNumber}} converted to Sales Order
                    <a [routerLink]="['/sales-order']" [queryParams]="{id: s.payloadDetails?.salesOrderId, module: soChannel.SALES_ORDER, data: s.payloadDetails?.salesOrderNo, globalSearch: 'true', channelId: '3', statusId: '1'}">{{s.payloadDetails?.salesOrderNo}}</a>
                </p>
                <!-- Estimates to Invoice Comment -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.payloadDetails?.invoiceId != 0 && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                    Estimate {{s?.moduleData?.sequenceNumber}} converted to Invoice
                    <a [routerLink]="['/invoicing']" [queryParams]="{id: s.payloadDetails?.invoiceId, module: 'Invoice', data: s.payloadDetails?.invoiceNo, globalSearch: 'true', channelId: '4', statusId: '1'}">{{s.payloadDetails?.invoiceNo}}</a>
                </p>
                <!-- Estimates Comment -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.payloadDetails?.salesOrderId == 0 && s.payloadDetails?.invoiceId == 0 && s.activitySource != 'WF' && s.objectData?.action != 'Approve/Decline'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment?.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment?.substring(0,343) + "..." }}
                </p>
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource == 'WF' && s.objectData?.action == 'Update' && s.objectData?.comment !== undefined && s.objectData?.comment !== '' && s?.objectData?.comment?.toLowerCase().includes('approved by')">
                    {{s.objectData?.comment}} {{s.createdByUserName}}
                </p>
                <!-- Estimate Approved/Declined by Approval Process -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF' && s.objectData?.action == 'Approve/Decline' && s.objectData?.comment !== undefined && s.objectData?.comment !== ''">
                    {{s.objectData?.comment}} {{s.createdByUserName}}
                </p>
                <!-- Estimate Pending For Approval -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'ApprovalFromWF'">
                    {{s.objectData?.comment}} through Workflow {{s.sourceName}}
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'SalesOrder' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span class="module-details">{{s.type}} {{s?.moduleData?.sequenceNumber}}</span> - {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData?.createdDate | localDate}}</span>
                </span>
                <div *ngIf="!s?.payloadDetails && s?.moduleData">{{ s | activityModuleDetails }}</div>
                <p class="p-mb-0" *ngIf="s.payloadDetails"> {{s.type}} - {{s.payloadDetails?.netAmount | customNumberFormat: fractionDigits | currencySymbol}} , {{s.payloadDetails?.salesOrderStage}} - {{s.objectData?.createdDate | localDate}}</p>
                <!-- Sales Order Create from Workflow -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action != 'Update' && s.objectData?.action != 'ApprovalFromWF'">
                    Sales Order {{s?.moduleData?.sequenceNumber}} is created from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <!-- Sales Order Update from Workflow -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'Update'">
                    Sales Order {{s?.moduleData?.sequenceNumber}} is updated from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <!-- Sales Order from Estimates -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.payloadDetails?.estimateId != 0 && s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                    Sales Order {{s?.moduleData?.sequenceNumber}} is created from Estimate
                    <a [routerLink]="['/estimates']" [queryParams]="{id: s.payloadDetails?.estimateId, module: 'Estimate', data: s.payloadDetails?.estimateNo, globalSearch: 'true', channelId: '2', statusId: '1'}">{{s.payloadDetails?.estimateNo}}</a>
                </p>
                <!-- Sales Order to Invoice -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData && s.objectData?.action == 'Update' && s.objectData?.comment?.includes('Converted to Invoice')">
                    Sales Order {{s?.moduleData?.sequenceNumber}} is converted to Invoice
                    <a [routerLink]="['/invoicing']" [queryParams]="{id: s.payloadDetails?.invoiceId, module: 'Invoice', data: s.payloadDetails?.invoiceNo, globalSearch: 'true', channelId: '4', statusId: '1'}">{{s.payloadDetails?.invoiceNo}}</a>
                </p>
                <!-- Sales Order update log -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData && s.objectData?.action == 'Update' && !s.objectData?.comment?.includes('Converted to Invoice') && s.activitySource != 'WF'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment?.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment?.substring(0,343) + "..." }}
                </p>
                <!-- Sales Order create log -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.payloadDetails && s.payloadDetails?.estimateId == 0 && s.activitySource != 'WF'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment?.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment?.substring(0,343) + "..." }}
                </p>
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource == 'WF' && s.objectData?.action == 'Update' && s.objectData?.comment !== undefined && s.objectData?.comment !== '' && s?.objectData?.comment?.toLowerCase().includes('approved by')">
                    {{s.objectData?.comment}} {{s.createdByUserName}}
                </p>
                <!-- SalesOrder Approved/Declined by Approval Process -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF' && s.objectData?.action == 'Approve/Decline' && s.objectData?.comment !== undefined && s.objectData?.comment !== ''">
                    {{s.objectData?.comment}} {{s.createdByUserName}}
                </p>
                <!-- SalesOrder Pending For Approval -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'ApprovalFromWF'">
                    {{s.objectData?.comment}} through Workflow {{s.sourceName}}
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && ['ActivitySalesOrderLog','ActivityCustomerRmaLog','ActivityInvoiceLog','ActivityCreditMemoLog'].includes(s.type)">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - Stage Changed {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all;" class="p-mb-0" [innerHTML]="s.objectData?.comment"></p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Invoice' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span class="module-details">{{s.type}} {{s?.moduleData?.sequenceNumber}}</span> - {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData?.createdDate | localDate}}</span>
                </span>
                <div *ngIf="!s?.payloadDetails && s?.moduleData">{{ s | activityModuleDetails }}</div>
                <p class="p-mb-0" *ngIf="s.payloadDetails"> {{s.type}} - {{s.payloadDetails?.netAmount | customNumberFormat: fractionDigits | currencySymbol}} , {{s.payloadDetails?.invoiceStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                <!-- Invoice create from Workflow -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action != 'Update' && s.objectData?.action != 'ApprovalFromWF'">
                    Invoice {{s?.moduleData?.sequenceNumber}} is created from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <!-- Invoice update from Workflow -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'Update'">
                    Invoice {{s?.moduleData?.sequenceNumber}} is updated from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <!-- Invoice from Estimates -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.payloadDetails?.estimateId != 0 && s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                    Invoice {{s?.moduleData?.sequenceNumber}} is created from Estimate
                    <a [routerLink]="['/estimates']" [queryParams]="{id: s.payloadDetails?.estimateId, module: 'Estimate', data: s.payloadDetails?.estimateNo, globalSearch: 'true', channelId: '2', statusId: '1'}">{{s.payloadDetails?.estimateNo}}</a>
                </p>
                <!-- Invoice from Sales Order -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.payloadDetails?.salesOrderId != 0 && s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.objectData?.action != 'ApprovalFromWF'">
                    Invoice {{s?.moduleData?.sequenceNumber}} is created from Sales Order
                    <a [routerLink]="['/sales-order']" [queryParams]="{id: s.payloadDetails?.salesOrderId, module: 'SalesOrder', data: s.payloadDetails?.salesOrderNo, globalSearch: 'true', channelId: '3', statusId: '1'}">{{s.payloadDetails?.salesOrderNo}}</a>
                </p>
                <!-- Invoice update log -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action == 'Update' && s.activitySource != 'WF'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                </p>
                <!-- Invoice create log -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action != 'Update' && s.objectData?.action != 'Approve/Decline' && s.payloadDetails && s.payloadDetails?.estimateId == 0 && s.payloadDetails?.salesOrderId == 0 && s.activitySource != 'WF'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                </p>
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource == 'WF' && s.objectData?.action == 'Update' && s.objectData?.comment !== undefined && s.objectData?.comment !== '' && s?.objectData?.comment?.toLowerCase().includes('approved by')">
                    {{s.objectData?.comment}} {{s.createdByUserName}}
                </p>
                <!-- Invoice Approved/Declined by Approval Process -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF' && s.objectData?.action == 'Approve/Decline' && s.objectData?.comment !== undefined && s.objectData?.comment !== ''">
                    {{s.objectData?.comment}} {{s.createdByUserName}}
                </p>
                <!-- Invoice Pending For Approval -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'ApprovalFromWF'">
                    {{s.objectData?.comment}} through Workflow {{s.sourceName}}
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Invoice Received Payment' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Invoice - {{s?.moduleData?.sequenceNumber}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData?.createdDate | localDate}}</span>
                </span>
                <p class="p-mb-0"> Invoice - {{s.payloadDetails?.netAmount | number: "1.2-2"}} , {{s.payloadDetails?.invoiceStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CustomerRma'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span class="module-details">{{s.type}} {{s?.moduleData?.sequenceNumber}}</span> - {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData?.createdDate | localDate}}</span>
                </span>
                <div *ngIf="!s?.payloadDetails && s?.moduleData">{{ s | activityModuleDetails }}</div>
                <p class="p-mb-0"> {{s.type}} - {{s.payloadDetails?.netAmount | customNumberFormat: fractionDigits | currencySymbol}} , {{s.payloadDetails?.rmaStatus}} - {{s.objectData?.createdDate | localDate}}</p>
                <!-- Customer RMA update log -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action == 'Update'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
                        <!-- Customer RMA create log -->
                        <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.objectData?.action != 'Update' && s.payloadDetails && s.payloadDetails?.estimateId == 0 && s.payloadDetails?.salesOrderId == 0">
                            {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                            < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'CreditMemo'">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span class="module-details">{{s.type}} {{s?.moduleData?.sequenceNumber}}</span> - {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData?.createdDate | localDate}}</span>
                </span>
                <div *ngIf="!s?.payloadDetails && s?.moduleData">{{ s | activityModuleDetails }}</div>
                <p *ngIf="s?.payloadDetails" class="p-mb-0"> {{s.type}} - {{s.payloadDetails?.netAmount | customNumberFormat: fractionDigits | currencySymbol}} , {{s.payloadDetails?.creditMemoStatus}} - {{s.objectData?.createdDate | localDate}}</p>

                <!-- Credit Memo is created from Workflow -->
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.payloadDetails && s.activitySource == 'WF' && s.objectData?.action == 'Insert'">
                    Credit memo {{s?.moduleData?.sequenceNumber}} is created from Workflow {{s.sourceName}}
                    <!-- <a [routerLink]="['/workflow']" [queryParams]="{id: s.sourceId, data: s.sourceName}">{{s.sourceName}}</a> -->
                </p>
                <p style="word-break: break-all;" class="p-mb-0" *ngIf="s.activitySource != 'WF'">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Product' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'PurchaseOrder' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ActivityPurchaseLog' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    Purchase {{ s | activityBy }} {{s.createdByUserName}} to {{s.objectData?.stage?.name}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0" [innerHTML]="s.objectData?.comment">
                    <!-- {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "")
                    && s.objectData?.comment.length < 343 ? s.objectData?.comment :
                    s.objectData?.comment.substring(0,343) + "..." }} -->
                </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Vendor' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'BillPayment' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Bill' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'ItemReceipt' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && s.type === 'Location' ">
                <h6 class="p-mb-1" style="display: inline-block;">
                    {{s.type}} {{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <p style="word-break: break-all;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }} </p>
            </ng-container>
            <ng-container *ngIf="s.activityName === 'ActivityFeed' && !s.type">
                <h6 class="p-mb-1" style="display: inline-block;">
                    <span *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId"><span (click)="openRecordDetails(s);$event.stopPropagation()" class="module-details">{{ s | activityModuleName }}</span> - </span>
                    <ng-container *ngIf="!s?.moduleData?.objectId">{{s.type}} </ng-container>{{ s | activityBy }} {{s.createdByUserName}}
                </h6>
                <span class="p-ml-4">
                    <span>{{s.objectData.createdDate | localDate}}</span>
                </span>
                <div *ngIf="objectTypeId!=s?.moduleData?.objectId && s?.moduleData?.objectId">{{ s | activityModuleDetails }}</div>
                <p style="word-break: break-all; white-space: pre-line;" class="p-mb-0">
                    {{ (s.objectData?.comment !== undefined || s.objectData?.comment !== "") && s.objectData?.comment.length
                    < 343 ? s.objectData?.comment : s.objectData?.comment.substring(0,343) + "..." }}
                    @if(s?.objectData?.action == 'Approve/Decline') {
                        {{ s.createdByUserName }}
                    }
                </p>
            </ng-container>
        </div>
    </div>
</p-card>

<p-card class="activity-card" *ngIf="(!allActivityLogs || !allActivityLogs.length)">
    <div>
        <h6 class="p-mb-1" style="display: inline-block;">
            No Activities
        </h6>
    </div>
</p-card>


<app-lion-comment-modal *ngIf="displayCommentAdd" [displayCommentAdd]="displayCommentAdd" [tempComment]="tempComment" [selectedCase]="selectedObject" [nextStageId]="nextStageIdForUpdate" [objectType]="currentObjectType" [commentHeaderTitle]="commentHeaderName"
    [commentFormType]="commentFormType" [caseStagesAll]="selectedObjectStages" [callFromTimeLine]="true" (commentSaved)="onCommentSaved($event)" (commentCancelClicked)="onCancelComment()" (commentDeleted)="onCommentDelete()">
</app-lion-comment-modal>

@if(displayLogDetailPopup){
<app-lion-log-details-popup [displayLogDetailPopup]="displayLogDetailPopup" [logData]="logData"
    [selectedModuleId]="objectTypeId" [selectedAccountId]="objectId" [isViewMode]="isViewMode"
    (cancelLogPopupDetails)="cancelLogPopupDetails()">
</app-lion-log-details-popup>
}

@if(displayNoteDetailPopup){
<app-lion-note-details-popup [displayNoteDetailPopup]="displayNoteDetailPopup" [selectedModuleId]="objectTypeId"
    [selectedAccountId]="objectId" [noteData]="noteData" [isViewMode]="isViewMode"
    (cancelNotePopupDetails)="cancelNotePopupDetails()">
</app-lion-note-details-popup>
}


<app-lion-email-details-popup [objectId]="objectId" [objectTypeId]="objectTypeId" (syncSendEmail)="syncSendEmail($event)" [displayEmailDetailPopup]="displayEmailDetailPopup"
    [emailAudit]="emailAudit" [emailAuditId]="emailAuditId" [isViewMode]="isViewMode" (cancelEmailPopupDetails)="cancelEmailPopupDetails()" (openEmailDetail)="openEmailDetail($event)">
</app-lion-email-details-popup>

<app-lion-email-reply-popup [displayEmailReplyPopup]="displayEmailReplyPopup" [emailReplyData]="emailReplyData" (cancelEmailReplyPopup)="cancelEmailReplyPopup()">
</app-lion-email-reply-popup>

<p-dialog header="Task Details" [(visible)]="displayTaskDetail" [modal]="true" [style]="{width: '55vw'}" [blockScroll]="true">
    <div class="header p-d-flex p-jc-between">
        <h5>Task ID: {{taskTemp.taskId}}</h5>
        <span class="btnBars p-mr-0" (click)="isView = !isView">
            <i class="pi pi-pencil" style="position: initial; margin-left: -2px;" *ngIf="isView"></i>
            <i class="pi pi-list" style="position: initial; margin-left: -2px;" *ngIf="!isView"></i>
        </span>
    </div>
    <div class="card" *ngIf="!isView">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Task Details <span style="color: red">*</span></label>
                <textarea pInputTextarea name="title" [(ngModel)]="taskTemp.header" rows="3" [ngClass]="{ 'ng-invalid': showValidation && !taskTemp.header }"></textarea>
                <small *ngIf="showValidation && !taskTemp.header" class="p-invalid">Task Title is required</small>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <label>Start Date & Time
                    <span style="color: red">*</span></label>
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{ standalone: true }" [minDate]="minimumDate" [(ngModel)]="taskTemp.fromTime" showTime="true"
                    [hourFormat]="12" [ngClass]="{
                        'ng-invalid': showValidation && !taskTemp.fromTime
                    }"></p-calendar>
                <small *ngIf="showValidation && !taskTemp.fromTime" class="p-invalid">Task start date is
                    required</small>
            </div>
            <div class="p-col-12 p-md-6">
                <label>End Date & Time <span style="color: red">*</span></label>
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{ standalone: true }" [minDate]="minimumDate" [(ngModel)]="taskTemp.endTime" showTime="true"
                    [hourFormat]="12" [ngClass]="{
                        'ng-invalid': showValidation && !taskTemp.endTime
                    }"></p-calendar>
                <small *ngIf="showValidation && !taskTemp.endTime" class="p-invalid">Task end date is required</small>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <label>Assigned to <span style="color: red">*</span></label>
                <p-multiSelect [options]="activeUsers" [(ngModel)]="selectedUsers" optionLabel="name" optionValue="id" placeholder="Select Users" [ngModelOptions]="{ standalone: true }" appendTo="body" [ngClass]="{
                        'ng-invalid':
                            showValidation &&
                            (!selectedUsers || !selectedUsers.length)
                    }">
                    <ng-template let-user pTemplate="item">
                        <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                            <div>{{user.name}}</div>
                        </div>
                    </ng-template>
                </p-multiSelect>
                <small *ngIf="
                        showValidation &&
                        (!selectedUsers || !selectedUsers.length)
                    " class="p-invalid">Task assign-to is required</small>
            </div>
            <div class="p-col-12 p-md-6">
                <label>Task Category <span style="color: red">*</span></label>
                <p-dropdown [options]="taskCategories" optionLabel="category.name" appendTo="body" optionValue="id" [(ngModel)]="selectedTaskCategory" [ngClass]="{
                        'ng-invalid': showValidation && !task.taskCategoryId
                    }"></p-dropdown>
                <small *ngIf="showValidation && !task.taskCategoryId" class="p-invalid">Task category is
                    required</small>
            </div>
        </div>
    </div>
    <div class="card" *ngIf="isView">
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Task Details:</strong></p>
            </div>
            <div class="p-col-8 p-md-10">
                <p>{{ taskTemp?.header }}</p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Start Date & Time: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ taskTemp?.fromTime | date:'short' }}</p>
            </div>
            <div class="p-col-4 p-md-2">
                <p><strong>End Date & Time: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ taskTemp?.endTime | date:'short' }}</p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Assigned to: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ taskTemp?.assignedTo }}</p>
            </div>
            <div class="p-col-4 p-md-2">
                <p><strong>Task Category: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ taskTemp?.category }}</p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Related to: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ taskTemp?.relatedTo }}</p>
            </div>
            <div class="p-col-4 p-md-2">
                <p><strong>Repeat Type: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ taskTemp?.repeatType }}</p>
            </div>
        </div>
    </div>
    <div class="header">
        <h5>Change Status</h5>
    </div>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <label>Status <span style="color: red">*</span></label>
                <p-dropdown [options]="taskStatuses" optionLabel="name" optionValue="id" [(ngModel)]="selectedTaskStatus" appendTo="body" placeholder="Select Status" [ngClass]="{
                        'ng-invalid':
                            showStatusValidation && !selectedTaskStatus
                    }"></p-dropdown>
                <small *ngIf="showStatusValidation && !selectedTaskStatus" class="p-invalid">Task status is
                    required</small>
            </div>

            <div class="p-col-12 p-md-6">
                <label>Share Files (Max Size 2MB) <i class="pi pi-exclamation-circle" [escape]="false"></i></label>
                <p-fileUpload name="demo[]" url="./upload.php" (onUpload)="onUpload($event)" multiple="multiple" accept="image/*" maxFileSize="1000000">
                    <ng-template pTemplate="content">
                        <ul *ngIf="uploadedFiles.length">
                            <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                        </ul>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>Comments <span style="color: red">*</span> </label>
                <textarea pInputTextarea name="description" [(ngModel)]="taskTemp.description" rows="3" [ngClass]="{
                        'ng-invalid':
                            showStatusValidation && !taskTemp.description
                    }"></textarea>
                <small *ngIf="showStatusValidation && !taskTemp.description" class="p-invalid">Task comments is
                    required</small>
            </div>
        </div>
        <div class="p-text-right">
            <button type="button" pButton label="Submit"></button>
        </div>
    </div>
    <div class="header">
        <h5>Status History</h5>
    </div>
    <div class="card">
        <p-panel *ngFor="let status of taskTemp?.taskStatuses">
            <p-header class="p-d-flex p-jc-between" style="width: 100%">
                <span><strong>{{ status.createdByUserName }}: </strong>
                    {{ status.taskStatus }}</span>
                <span>{{ status.createdDate | localDate }}</span>
            </p-header>
            <p class="p-mb-0">Comments: {{ status.description }}</p>
            <div style="margin-bottom: 10px"></div>
        </p-panel>
        <ng-container *ngIf="!taskTemp?.taskStatuses?.length">
            <div class="p-grid statuses">
                <div class="p-col-12">
                    <strong>Status history is empty.</strong>
                </div>
            </div>
        </ng-container>
    </div>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="isView">
            <button pButton (click)="displayTaskDetail=false;isView=true;" label="Cancel" class="p-button-secondary"></button>
        </ng-container>
        <ng-container *ngIf="!isView">
            <button pButton (click)="isView=true;" label="Cancel" class="p-button-secondary"></button>
            <button pButton label="Save"></button>
        </ng-container>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="displayEventDetail" [modal]="true" [style]="{width: '55vw'}" [blockScroll]="true">
    <div class="header p-d-flex p-jc-between">
        <h5>Event Details</h5>
        <span class="btnBars p-mr-0" (click)="isView = !isView">
            <i class="pi pi-pencil" style="position: initial; margin-left: -2px;" *ngIf="isView"></i>
            <i class="pi pi-list" style="position: initial; margin-left: -2px;" *ngIf="!isView"></i>
        </span>
    </div>
    <div class="card" *ngIf="!isView">
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex">
                    <label class="p-mt-2">Title: <span style="color: red">*</span></label>
                    <div style="flex-grow: 1;" class="p-ml-2 border-bottom">
                        <input pInputTextarea name="title" [(ngModel)]="eventTemp.header" [ngClass]="{ 'ng-invalid': showValidation && !eventTemp.header }">
                        <small *ngIf="showValidation && !eventTemp.header" class="p-invalid">Title is required</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex p-jc-between">
                    <label>Reuquired: </label>
                    <div style="flex-grow: 1;" class="p-mx-2 border-bottom">
                        <p-autoComplete field="name" [required]="true" name="toRecipients" class="width-inherit" placeholder="Add required attendees" #toRecipients id="toRecipients" [ngModelOptions]="{ standalone: true }" [suggestions]="usersList" [completeOnFocus]="true" appendTo="body"
                            (completeMethod)="search($event.query)" [multiple]="true">
                            <ng-template let-toRecipients pTemplate="item">
                                {{toRecipients.name + "
                                < " +toRecipients.emailId +">"}}
                            </ng-template>
                        </p-autoComplete>
                    </div>
                    <button pButton class="right-button" type="button" icon="pi pi-plus" label="Optional" (click)="showOptional()"></button>
                </div>
                <div class="p-d-flex" *ngIf="isShownOptional">
                    <div class="p-mt-3">Optional: </div>
                    <div style="flex-grow: 1;" class="p-mx-2 border-bottom">
                        <p-autoComplete class="width-inherit" appendTo="body" field="name" name="optRecipients" placeholder="Add optional attendees" id="optRecipients" [suggestions]="usersList" [completeOnFocus]="true" [ngModelOptions]="{ standalone: true }" [multiple]="true"
                            (completeMethod)="search($event.query)" appendTo="body">
                            <ng-template let-optRecipients pTemplate="item">
                                {{optRecipients.name + "
                                < " +optRecipients.emailId +">"}}
                            </ng-template>
                        </p-autoComplete>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12 p-md-3">
                <label>Start Date & Time <span style="color: red">*</span></label>
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{ standalone: true }" [minDate]="minimumDate" [(ngModel)]="eventTemp.fromTime" showTime="true"
                    [hourFormat]="12" [ngClass]="{
                    'ng-invalid': showValidation && !eventTemp.fromTime
                }"></p-calendar>
                <small *ngIf="showValidation && !eventTemp.fromTime" class="p-invalid">Event start date is
                    required</small>
            </div>
            <div class="p-col-12 p-md-3">
                <label>End Date & Time <span style="color: red">*</span></label>
                <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" [ngModelOptions]="{ standalone: true }" [minDate]="minimumDate" [(ngModel)]="eventTemp.endTime" showTime="true"
                    [hourFormat]="12" [ngClass]="{
                        'ng-invalid': showValidation && !eventTemp.endTime
                    }"></p-calendar>
                <small *ngIf="showValidation && !eventTemp.endTime" class="p-invalid">Event end date is required</small>
            </div>
            <div class="p-col-12 p-md-3 p-mt-5">
                <p-checkbox name="allday" binary="true" value="All Day" inputId="allDay"></p-checkbox>
                <label for="allday" class="p-d-inline-block p-mb-1 p-ml-2">All day</label>
            </div>
            <div class="p-col-12 p-md-3 p-mt-5">
                <div pButton type="button" label="Change Recurring" (click)="showCustom()"></div>
            </div>
        </div>
        <p>
            <i class="pi pi-check-circle p-mr-1" style="color:#9fd037"></i> {{ evtMsg }}
        </p>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex p-jc-between">
                    <label>Location: </label>
                    <div style="flex-grow: 1;" class="p-mx-2 border-bottom">
                        <input type="text" pInputText [(ngModel)]="eventTemp.location" />
                    </div>
                    <div class="p-logo-section">
                        <ul class="logo-list p-d-flex">
                            <li class="logo">
                                <img src="https://heliocentrix.co.uk/wp-content/uploads/2020/04/microsoft-teams-logo-png_480-480.png" alt="Teams" (click)="setOnlineMeetings('Teams')" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>Description: </label>
                <p-editor [(ngModel)]="eventTemp.description" placeholder="Add your message..." [style]="{'height':'220px'}">
                </p-editor>
            </div>
        </div>
    </div>
    <div class="card" *ngIf="isView">
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Title:</strong></p>
            </div>
            <div class="p-col-8 p-md-10">
                <p>{{ eventTemp?.header }}</p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Attendy list:</strong></p>
            </div>
            <div class="p-col-8 p-md-10">
                <p>
                    <ng-container *ngFor="let u of eventTemp.userLists; let i = index;">
                        {{ u?.name }}
                        <span *ngIf="eventTemp.userLists.length > 1 && i !== eventTemp.userLists.length-1">,</span>
                    </ng-container>
                </p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Start Date & Time: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ eventTemp?.fromTime | date:'short' }}</p>
            </div>
            <div class="p-col-4 p-md-2">
                <p><strong>End Date & Time: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ eventTemp?.endTime | date:'short' }}</p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Location: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ eventTemp?.location }}</p>
            </div>
            <div class="p-col-4 p-md-2">
                <p><strong>Repeat: </strong></p>
            </div>
            <div class="p-col-8 p-md-4">
                <p>{{ eventTemp?.repeatType }}</p>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-4 p-md-2">
                <p><strong>Description: </strong></p>
            </div>
            <div class="p-col-8 p-md-10">
                <p>{{ eventTemp?.message }}</p>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="isView">
            <button pButton (click)="displayEventDetail=false;isView=true;" label="Cancel" class="p-button-secondary"></button>
        </ng-container>
        <ng-container *ngIf="!isView">
            <button pButton (click)="isView=true;" label="Cancel" class="p-button-secondary"></button>
            <button *ngIf="!isView" pButton label="Save"></button>
        </ng-container>
    </ng-template>
</p-dialog>

<app-shared-detail-popup *ngIf="displayDetailPopup" [moduleType]="moduleType" [currentDisplay]="displayDetailPopup" [header]="popupHeader" [associationTypeId]="associationTypeId" [dataId]="dataId" (dialogClosed)="closeDialog()">
</app-shared-detail-popup>

<app-lion-shared-emails [objectTypeId]="objectTypeId" [displaySendEmail]="displaySendEmail" [contacts]="contacts" [selectedObject]="selectedObject" [channelId]="channelId" [objectId]="objectId" [objectTypeId]="objectTypeId" (cancelEmail)="cancelEmail($event)"
    (syncSendEmail)="syncSendEmail($event)">
</app-lion-shared-emails>

<app-lion-shared-logs *ngIf="displayAddLog" [displayAddLog]="displayAddLog" (cancelLog)="cancelLog($event)">
</app-lion-shared-logs>

<app-lion-shared-notes *ngIf="displayNotesAdd" [displayNotesAdd]="displayNotesAdd" (cancelNote)="cancelNote($event)">
</app-lion-shared-notes>

<app-lion-active-inactive-modal *ngIf="displayActiveInactiveModal" [commentHeaderName]="commentHeaderName" [displayActiveInactiveModal]="displayActiveInactiveModal" [activeInactiveFormType]="activeInactiveFormType" [activeInactiveData]="activeInactiveData"
    [moduleName]="moduleName" (cancelActiveInactiveModal)="cancelActiveInactiveModal()">
</app-lion-active-inactive-modal>

<!-- Account Edit Component -->
<app-edit-account *ngIf="displayOverviewPopup && moduleType == objectNames.ACCOUNT"
    [displayEditViewDialog]="displayOverviewPopup"
    [displayView]="true"
    [selectedAccountId]="dataId"
    (closeModal)="closeDialog()">
</app-edit-account>

<!-- Lead View/Edit -->
<app-add-update-view-lead *ngIf="displayOverviewPopup && moduleType == objectNames.LEADS" [display]="true"
    [selectedLeadId]="dataId"
    [crudType]="'view'"
    (cancelClicked)="closeDialog()">
</app-add-update-view-lead>

<!-- Opportunity View/Edit -->
<app-opportunity-add-edit-dialog *ngIf="displayOverviewPopup && moduleType == objectNames.OPPORTUNITY"
    [displayAddEditDialog]="displayOverviewPopup"
    [opportunityId]="dataId" [crudType]="'view'"
    (closeModal)="closeDialog()">
</app-opportunity-add-edit-dialog>

<!-- Cases Add/Edit/View -->
<app-cases-add-edit-dialog *ngIf="displayOverviewPopup && moduleType == objectNames.CASES"
    [displayAddEditDialog]="displayOverviewPopup"
    [casesId]="dataId" [crudType]="'view'"
    (closeModal)="closeDialog()">
</app-cases-add-edit-dialog>

<!-- Inventory Overview -->
<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>

<ng-container *ngIf="displayUserDetails&&selectedUserId">
    <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUserId"
    (close)="closeTaggedUserDetails()"></user-details-modal>
  </ng-container>
